import baseAPI from '@/api/base';
import { EditPayrollPeriod, GetPayrollPeriod, RegisterPayrollPeriod } from '@/dtos/payroll_period.dto';
import {
  DELETE_PAYROLL_PERIOD_URL,
  EDIT_PAYROLL_PERIOD_URL,
  GET_PAYROLL_PERIOD_URL,
  REGISTER_PAYROLL_PERIOD_URL,
  TOGGLE_PAYROLL_PERIOD_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class PayrollPeriod {
  static getPayrollPeriods = async (getPayrollPeriods: GetPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PAYROLL_PERIOD_URL, {
      params: getPayrollPeriods,
    });
    console.log('response', response);
    return response;
  };

  static registerPayrollPeriod = async (
    registerPayrollPeriod: RegisterPayrollPeriod
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_PAYROLL_PERIOD_URL, {
      ...registerPayrollPeriod,
    });
    console.log('response', response);
    return response;
  };

  static editPayrollPeriod = async (editPayrollPeriod: EditPayrollPeriod): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_PAYROLL_PERIOD_URL, {
      ...editPayrollPeriod,
    });
    return response;
  };

  static togglePayrollPeriodIsActive = async (
    editPayrollPeriod: EditPayrollPeriod
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PAYROLL_PERIOD_IS_ACTIVE_URL,
      {
        ...editPayrollPeriod,
      }
    );
    return response;
  };

  static deletePayrollPeriod = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PAYROLL_PERIOD_URL}/${userId}`
    );
    return response;
  };
}

export default PayrollPeriod;
